export default __webpack_public_path__ + "static/logo3-3f4546f2383081e6d7b97993e87ca897.png";